"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fromStorage = (storage = window.localStorage) => ({ storageName, initialValue, decoder, logger }) => () => {
    const storedString = storage.getItem(storageName);
    if (!storedString) {
        return initialValue;
    }
    try {
        return decoder(storedString);
    }
    catch (e) {
        if (logger?.logError) {
            logger.logError(`Decoding ${storageName} from local storage failed`);
        }
        return initialValue;
    }
};
exports.default = fromStorage;
